/**
 * Card-Komponente – schlichte Karte mit Titelzeile und Icon
 */

import React from 'react';
import '../css/card.css';
import { Box } from '@mui/material';
import { Icon } from '../icons/AppIcons';

const TITLE_ICONS = [
  { match: 'Temperatur', name: 'temperature' },
  { match: 'Feuchtigkeit', name: 'humidity' },
  { match: 'Messwerte', name: 'charts' },
  { match: 'Anschlüsse', name: 'fire' },
  { match: 'Diagramme', name: 'charts' },
  { match: 'Übersicht', name: 'dashboard' },
  { match: 'Signal', name: 'signal' },
  { match: 'Status', name: 'status' },
  { match: 'Aktionen', name: 'settings' },
  { match: 'Aktionsverlauf', name: 'history' },
  { match: 'Ereignisse', name: 'events' },
  { match: 'Logs', name: 'logs' },
  { match: 'Standort', name: 'location' },
  { match: 'Koffer', name: 'koffer' },
  { match: 'Online', name: 'online' },
  { match: 'Offline', name: 'offline' },
  { match: 'Alarm', name: 'alarm' },
];

export default function Card(props) {
  const iconName = props.icon || TITLE_ICONS.find((item) => props.title && props.title.includes(item.match))?.name;

  return (
    <div className={`card-container card-${props.width}${props.plain ? ' is-plain' : ''}`}>
      {!props.plain && (
        <div className="card-container-title">
          <div className="card-container-text">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {iconName && <Icon name={iconName} size={22} />}
              {props.title}
            </Box>
          </div>
          <div className="card-container-buttons">
            {props.add ? props.add : ''}
          </div>
        </div>
      )}
      <div className="card-container-body">
        {props.data}
      </div>
    </div>
  );
}
